module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "App",
    class: _vm.appClasses,
    style: (_vm.appStyles),
    attrs: {
      "id": "app"
    }
  }, [_c('overlay-menu'), _vm._v(" "), _c('router-view', {
    staticClass: "App-content"
  }), _vm._v(" "), _c('share-modal'), _vm._v(" "), _c('viewer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-887ca2b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/App.vue
// module id = 788
// module chunks = 1474